/**
 * Constantes del informe de valoración de existencias. Espejo de
 * `mirtomex-back/src/services/reports/stocks/types.ts`: si se añade una
 * dimensión o medida allí, hay que añadirla aquí con su etiqueta.
 */

export const DIMENSIONS = [
  { key: 'deposit', label: 'Depósito', short: 'Depósito' },
  { key: 'depositType', label: 'Tipo de depósito', short: 'Tipo' },
  { key: 'gender', label: 'Género', short: 'Género' },
  { key: 'category', label: 'Categoría', short: 'Categoría' },
  { key: 'subcategory', label: 'Subcategoría', short: 'Subcat.' },
  { key: 'season', label: 'Temporada', short: 'Temporada' },
  { key: 'year', label: 'Año', short: 'Año' },
  { key: 'campaign', label: 'Campaña', short: 'Campaña' },
];

export const DIMENSION_BY_KEY = DIMENSIONS.reduce((acc, d) => ({ ...acc, [d.key]: d }), {});

/**
 * `kind` decide el formateo: unidades, dinero (moneda activa) o conteo. El
 * orden de la lista es el de la barra, la tabla, los KPIs y los exports.
 */
export const MEASURES = [
  { key: 'qty', label: 'Uds.', long: 'Unidades', kind: 'units' },
  { key: 'families', label: 'Serie-color', long: 'Series-color distintas', kind: 'count' },
  { key: 'cost', label: 'Coste', long: 'Valor a coste', kind: 'money' },
  { key: 'pvf', label: 'PVF', long: 'Valor PVF (sin IVA)', kind: 'money' },
  { key: 'pvp', label: 'PVP', long: 'Valor PVP (precio etiqueta)', kind: 'money' },
];

export const MEASURE_BY_KEY = MEASURES.reduce((acc, m) => ({ ...acc, [m.key]: m }), {});
export const ALL_MEASURE_KEYS = MEASURES.map((m) => m.key);

/** Escala de los importes en tabla y PDFs. La unidad se declara una vez en la cabecera. */
export const MONEY_SCALES = [
  { key: 'full', label: 'Completos', factor: 1, suffix: '' },
  { key: 'k', label: 'En miles', factor: 1e3, suffix: 'miles' },
  { key: 'M', label: 'En millones', factor: 1e6, suffix: 'millones' },
];
export const DEFAULT_MONEY_SCALE = 'k';

/** Vistas predefinidas. Las claves coinciden con `STOCK_PIVOT_PRESETS` del back. */
export const PRESETS = [
  { key: 'byDeposit', label: 'Por depósito', rows: ['deposit'], cols: ['gender'] },
  { key: 'byGenderCategory', label: 'Por género y categoría', rows: ['gender', 'category', 'subcategory'], cols: [] },
  { key: 'byCampaign', label: 'Por campaña', rows: ['gender', 'category'], cols: ['campaign'] },
  { key: 'byAge', label: 'Antigüedad del stock', rows: ['deposit'], cols: ['year'] },
];

export const DEFAULT_PRESET = PRESETS[0];
export const DEFAULT_MEASURES = ['qty', 'pvf'];

export const MAX_ROW_LEVELS = 4;
export const MAX_COL_LEVELS = 3;

/** Filtros de catálogo. Se hidratan desde `/products/filters` (slugs del back). */
export const BASE_FILTERS = {
  genders: { name: 'Género', slug: 'genders', bundle: true },
  categories: { name: 'Categorías', slug: 'categories', bundle: true },
  subcategories: { name: 'Subcategorías', slug: 'subcategories', bundle: true },
  seasons: { name: 'Temporadas', slug: 'seasons', bundle: true },
  years: { name: 'Años', slug: 'years', bundle: true },
};

/** Clave del nodo raíz (gran total) en el árbol pivot. */
export const ROOT_KEY = 'TOTAL';

/** Devuelve el preset cuyas filas y columnas coinciden exactamente, o `null`. */
export const matchPreset = (rows, cols) =>
  PRESETS.find((p) => p.rows.join(':') === rows.join(':') && p.cols.join(':') === cols.join(':')) || null;
